module.exports = __webpack_public_path__ + "resources/img/equipment_tab2_img4.967c448d2ae785fd49609edf09919f55.jpg";